<div id="locationlink-list">
  <ng-container *ngFor="let perimeter of perimeterData; let i = index">
    <ul>
      <li>
        <a (click)="getPerimeter(perimeter, i)" [ngClass]="(clickedIndex === i) ? 'activeBtn': ''"
          >{{perimeter.firename}}
          <div id="gcid" style="display: none">{{perimeter.gcid}}</div>
          <div id="locationextent" style="display: none">
            {{perimeter.extent}}
          </div></a
        >
      </li>
    </ul>
  </ng-container>
</div>
<div class="buttonDiv">
  <a style="text-decoration: none !important;"
    class="closer tool-toolTip"
    (click)="closeLeft()"
  >
    <img
      class="closer-img common-btns"
      src="/assets/img/tools/close-pv3.png"
      alt="closer"
    /><span class="tooltiptext tip-bottom" style="text-decoration: none !important;"
      ><strong style="text-decoration: none !important;">Close</strong>
      <p style="text-decoration: none !important;">Close panel</p></span
    >
  </a>
</div>